<script>
import Swiper from "swiper";

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    swiperController: null,
  }),

  computed: {
    navigation() {
      if (this.options.navigation) {
        const nav = { ...this.options.navigation };

        nav.prevEl = nav.prevEl.replace(".", "");
        nav.nextEl = nav.nextEl.replace(".", "");

        return nav;
      } else {
        return {};
      }
    },
  },

  mounted() {
    this.swiperController = new Swiper(this.$refs.swiper, this.options);
  },

  methods: {
    onPrev() {
      this.swiperController?.slidePrev();
    },
    onNext() {
      this.swiperController?.slideNext();
    },
  },
};
</script>

<template>
  <div ref="swiper" class="swiper-container">
    <div class="swiper-wrapper">
      <slot />
    </div>
    <template v-if="options.navigation">
      <div
        v-if="navigation.prevEl"
        :class="navigation.prevEl"
        @click="onPrev"
      />
      <div
        v-if="navigation.nextEl"
        :class="navigation.nextEl"
        @click="onNext"
      />
    </template>
  </div>
</template>
